export default `#define Q(p) p*=rot(round(atan(p.y,p.x)/a)*a),
float de(vec3 p){
  float a = PI/8.0;
  for(int i=0;i++<5;)
    Q(p.yx)p.y-=1.,
    Q(p.zy)p.z-=1.;
  return.5*abs(length(p+p.zxy)-.05)+1e-3;
}`